import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import { CommonService } from './common.service';
import { Task } from '../models/task.model';

@Injectable({
  providedIn: 'root'
})
export class TasksService extends CommonService {

  constructor(
    private httpClient: HttpClient,
  ) { 
    super(httpClient);
  }

  public getVehicles(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/vehicles?${this.parseQueryParams(data)}`);
  }

  public getVehicle(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/vehicles/${id}`);
  }

  public createVehicle(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/vehicles`, data);
  }

  public updateVehicle(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/vehicles/${id}`, data);
  }

  public updateAssignedVehicle(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/vehicles/user/${id}`, data);
  }

  public getUserVehicle(id: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/vehicles/user/${id}`);
  }

  public removeUserVehicle(id: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/vehicles/user/${id}`);
  }

  public deleteVehicle(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/vehicles/${id}`);
  }

  public getTools(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tools?${this.parseQueryParams(data)}`);
  }

  public getTool(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tools/${id}`);
  }

  public createTool(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/tools`, data);
  }

  public updateTool(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/tools/${id}`, data);
  }

  public getUserTools(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tools/user/${id}`);
  }

  public addUserTool(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/tools/user/${id}`, data);
  }

  public removeUserTool(id: any): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/tools/user/${id}`);
  }

  public deleteTool(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/tools/${id}`);
  }

  public getSkills(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/skills?${this.parseQueryParams(data)}`);
  }

  public getSkill(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/skills/${id}`);
  }

  public createSkill(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/skills`, data);
  }

  public updateSkill(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/skills/${id}`, data);
  }

  public deleteSkill(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/skills/${id}`);
  }

  public getUserSkills(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/skills/user/${id}`);
  }

  public addUserSkill(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/skills/user`, data);
  }

  public removeUserSkill(data: any): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/skills/user`, data);
  }

  public getTechSkills(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/skills/tech/${id}`);
  }

  public getBuilders(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/builders?${this.parseQueryParams(data)}`)
    .pipe(catchError(this.errorHandler))
    .pipe(map((data: any) => {
      const builders: any[] = [];
      console.log('data SERVICE =>==> ', data);
      data?.data.map((builderData: any) => {
        const builder = {
          id: builderData?.id,
          created_at: builderData?.created_at,
          updated_at: builderData?.updated_at,
          profile_id: builderData?.profile_id,
          status: builderData?.status,
          name: builderData?.name,
          proximity: builderData?.proximity,
          checkin_type: builderData?.checkin_type,
          checkin_radius: builderData?.checkin_radius,
          depth: builderData?.depth,
          checkout: builderData?.checkout,
          activities: builderData?.activities,
        };
        builders.push(builder);
      });
      return builders;
    }
    ));
  }

  public getBuilder(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/builders/${id}`)
    .pipe(catchError(this.errorHandler))
    .pipe(map((data: any) => {
      const builder = {
        id: data?.data?.id,
        created_at: data?.data?.attributes?.created_at,
        updated_at: data?.data?.attributes?.updated_at,
        profile_id: data?.data?.attributes?.profile_id,
        status: data?.data?.attributes?.status,
        name: data?.data?.attributes?.name,
        proximity: data?.data?.attributes?.proximity,
        checkin_type: data?.data?.attributes?.checkin_type,
        checkin_radius: data?.data?.attributes?.checkin_radius,
        depth: data?.data?.attributes?.depth,
        checkout: data?.data?.attributes?.checkout,
        activities: data?.data?.attributes?.activities,
      };
      return builder;
    }
    ));
  }

  public createBuilder(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/builders`, data);
  }

  public updateBuilder(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/builders/${id}`, data);
  }

  public deleteBuilder(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/builders/${id}`);
  }

  public getActivities(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/activities?${this.parseQueryParams(data)}`);
  }

  public getActivity(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/activities/${id}`);
  }

  public createActivityTools(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activities/tools`, data);
  }

  public createActivitySkills(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activities/skills`, data);
  }

  public deleteActivitySkills(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activities/remove/skills`, data);
  }

  public deleteActivityTools(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activities/remove/tools`, data);
  }

  public createActivity(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activities`, data);
  }

  public updateActivity(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/activities/${id}`, data);
  }

  public deleteActivity(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/activities/${id}`);
  }

  public getActivityTypes(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/activity_types?${this.parseQueryParams(data)}`);
  }

  public getActivityType(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/activity_types/${id}`);
  }

  public createActivityType(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/activity_types`, data);
  }

  public updateActivityType(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/activity_types/${id}`, data);
  }

  public deleteActivityType(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/activity_types/${id}`);
  }

  public getTaskCategories(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/task-categories?${this.parseQueryParams(data)}`);
  }

  public getTaskCategory(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/task-categories/${id}`);
  }

  public createTaskCategory(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/task-categories`, data);
  }

  public updateTaskCategory(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/task-categories/${id}`, data);
  }

  public deleteTaskCategory(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/task-categories/${id}`);
  }

  public getTasks(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tasks?${this.parseQueryParams(data)}`)
    .pipe(catchError(this.errorHandler))
    .pipe(map((data: any) => {
      const tasks: Task[] = [];
      console.log('data SERVICE =>==> ', data);
      data?.data.map((taskData: any) => {
        const task: Task = {
        id: taskData?.id,
        title: taskData?.attributes?.title,
        completed: taskData?.attributes?.completed,
        priority: taskData?.attributes?.priority,
        due_date: taskData?.attributes?.due_date,
        created_at: taskData?.attributes?.created_at,
        updated_at: taskData?.attributes?.updated_at,
        task_category_id: taskData?.attributes?.task_category_id,
        builder_id: taskData?.attributes?.builder_id,
        task_category: taskData?.attributes?.task_category,
        builder: taskData?.attributes?.builder,
        assignee_id: taskData?.attributes?.assignee_id,
        profile_id: taskData?.attributes?.profile_id,
        due_time: taskData?.attributes?.due_time,
        completed_at: taskData?.attributes?.completed_at,
        status: taskData?.attributes?.status,
        settlement_id: taskData?.attributes?.settlement_id,
        building_id: taskData?.attributes?.building_id,
        unit_id: taskData?.attributes?.unit_id,
        tank_id: taskData?.attributes?.tank_id,
        po_id: taskData?.attributes?.po_id,
        duration: taskData?.attributes?.duration,        
        }
        tasks.push(task);
      });
      const meta: any = {
        per_page: data?.params?.per_page,
        total_entries: data?.meta?.pagination?.total_entries,
        current_page: data?.meta?.pagination?.current_page,
      };
      return { data: tasks, meta: meta };
    }));
  }

  public getTask(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tasks/${id}`)
    .pipe(catchError(this.errorHandler))
    .pipe(map((data: any) => {
      console.log('data SERVICE =>==> ', data);
      const task: Task = {
        id: data?.data?.id,
        title: data?.data?.attributes?.title,
        completed: data?.data?.attributes?.completed,
        priority: data?.data?.attributes?.priority,
        due_date: data?.data?.attributes?.due_date,
        created_at: data?.data?.attributes?.created_at,
        updated_at: data?.data?.attributes?.updated_at,
        task_category_id: data?.data?.attributes?.task_category_id,
        builder_id: data?.data?.attributes?.builder_id,
        task_category: data?.data?.attributes?.task_category,
        builder: data?.data?.attributes?.builder,
        assignee_id: data?.data?.attributes?.assignee_id,
        profile_id: data?.data?.attributes?.profile_id,
        due_time: data?.data?.attributes?.due_time,
        completed_at: data?.data?.attributes?.completed_at,
        status: data?.data?.attributes?.status,
        settlement_id: data?.data?.attributes?.settlement_id,
        building_id: data?.data?.attributes?.building_id,
        unit_id: data?.data?.attributes?.unit_id,
        tank_id: data?.data?.attributes?.tank_id,
        po_id: data?.data?.attributes?.po_id,
      }
      console.log('task SERVICE =>==> ', task);
      return task;
    }));
  }

  public getTaskReview(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tasks/review/${id}`);
  }

  public createTask(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/tasks`, data);
  }

  public updateTask(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/tasks/${id}`, data);
  }

  public cancelTask(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tasks/cancel/${id}`);
  }
  
  public getWorkHours(): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/work_hours`);
  }

  public getWorkHour(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/work_hours/${id}`);
  }

  public createWorkHour(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/work_hours`, data);
  }

  public updateWorkHour(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/work_hours/${id}`, data);
  }

  public deleteWorkHour(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/work_hours/${id}`);
  }

  public getTechStats(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stats?${this.parseQueryParams(data)}`);
  }

  public getTechStat(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stats/${id}`);
  }

  public getTechStatsSummary(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stats/summary?${this.parseQueryParams(data)}`);
  }

  // CRUD for holidays

  public getHolidays(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/work_schedules?${this.parseQueryParams(data)}`);
  }

  public getHoliday(id: number): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/work_schedules/${id}`);
  }

  public createHoliday(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskURL}/work_schedules`, data);
  }

  public updateHoliday(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskURL}/work_schedules/${id}`, data);
  }

  public deleteHoliday(id: number): Observable<any> {
    return this.httpClient.delete(`${this.taskURL}/work_schedules/${id}`);
  }

  public getTechStatSummaries(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stat_summaries?${this.parseQueryParams(data)}`);
  }

  public getTechStatSummary(id: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stat_summaries/${id}`);
  }

  public getTechStatSummariesFilter(data: any): Observable<any> {
    return this.httpClient.get(`${this.taskURL}/tech_stat_summaries/datefilter?${this.parseQueryParams(data)}`);
  }


}
